import createIcon from '../../createIcon';

/**
 * @component @name AutoAwesomeMotion
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgMkg0QzIuODkgMiAyIDIuOSAyIDRWMTRINFY0SDE0VjJaTTE4IDZIOEM2Ljg5IDYgNiA2LjkgNiA4VjE4SDhWOEgxOFY2Wk0yMCAxMEgxMkMxMC44OSAxMCAxMCAxMC45IDEwIDEyVjIwQzEwIDIxLjEgMTAuODkgMjIgMTIgMjJIMjBDMjEuMSAyMiAyMiAyMS4xIDIyIDIwVjEyQzIyIDEwLjkgMjEuMSAxMCAyMCAxMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AutoAwesomeMotion = createIcon('AutoAwesomeMotion', [
  [
    'path',
    {
      d: 'M14 2H4C2.89 2 2 2.9 2 4V14H4V4H14V2ZM18 6H8C6.89 6 6 6.9 6 8V18H8V8H18V6ZM20 10H12C10.89 10 10 10.9 10 12V20C10 21.1 10.89 22 12 22H20C21.1 22 22 21.1 22 20V12C22 10.9 21.1 10 20 10Z',
      key: 'jq9j94',
    },
  ],
]);

export default AutoAwesomeMotion;
